enum EOperadorFiltro {
  //Indefinido = '',
  Todos = 'TODOS',
  Igual = 'IGUAL',
  Maior = 'MAIOR',
  Menor = 'MENOR',
  MaiorOuIgual = 'MAIOR_OU_IGUAL',
  MenorOuIgual = 'MENOR_OU_IGUAL',
  Diferente = 'DIFERENTE',
  Contendo = 'CONTENDO',
  NaoContendo = 'NAO_CONTENDO',

  Vazio = 'VAZIO',
  NaoVazio = 'NAO_VAZIO',

  Contido = 'CONTIDO',
  NaoContido = 'NAO_CONTIDO',
}

export default EOperadorFiltro;

export const cNOME_AMIGAVEL_OPERADORES: Record<EOperadorFiltro, string> = {
  //[EOperadorFiltro.Indefinido]: 'Indefinido',
  [EOperadorFiltro.Todos]: 'Todos',
  [EOperadorFiltro.Igual]: 'Igual',
  [EOperadorFiltro.Maior]: 'Maior',
  [EOperadorFiltro.Menor]: 'Menor',
  [EOperadorFiltro.MaiorOuIgual]: 'Maior ou Igual',
  [EOperadorFiltro.MenorOuIgual]: 'Menor ou Igual',
  [EOperadorFiltro.Diferente]: 'Diferente',
  [EOperadorFiltro.Contendo]: 'Contendo',
  [EOperadorFiltro.NaoContendo]: 'Não Contendo',
  [EOperadorFiltro.Contido]: 'Contido Em',
  [EOperadorFiltro.NaoContido]: 'Não Contido Em',
  [EOperadorFiltro.Vazio]: 'Vazio',
  [EOperadorFiltro.NaoVazio]: 'Não Vazio',
};

export const cICONE_OPERADORES: Record<EOperadorFiltro, string> = {
  //[EOperadorFiltro.Indefinido]: 'mdi-help-circle',
  [EOperadorFiltro.Todos]: 'mdi-check-circle',
  [EOperadorFiltro.Igual]: 'mdi-equal',
  [EOperadorFiltro.Maior]: 'mdi-greater-than',
  [EOperadorFiltro.Menor]: 'mdi-less-than',
  [EOperadorFiltro.MaiorOuIgual]: 'mdi-greater-than-or-equal',
  [EOperadorFiltro.MenorOuIgual]: 'mdi-less-than-or-equal',
  [EOperadorFiltro.Diferente]: 'mdi-not-equal-variant',
  [EOperadorFiltro.Contendo]: 'mdi-contain',
  [EOperadorFiltro.NaoContendo]: 'mdi-contain',
  [EOperadorFiltro.Contido]: 'mdi-playlist-check',
  [EOperadorFiltro.NaoContido]: 'mdi-playlist-remove',

  [EOperadorFiltro.Vazio]: '',
  [EOperadorFiltro.NaoVazio]: '',
};
